import { Api as Customer } from './customer';
import { Api as Goods } from './goods';
import { Api as Order } from './order';
import { Api as Settlement } from './settlement';
import { Api as Smc } from './smc';
import { Api as Wms } from './wms';
import { Api as Overseas } from './overseas';
import { Api as Apis } from './apis';
import { Api as Market } from './market';
import { Api as Purchase } from './purchase';

import { serviceConfig } from '@/config/request/swaggerServiceConfig';

export const Api = { Customer, Goods, Order, Settlement, Smc, Wms, Overseas, Apis, Market, Purchase };

const warpperServiceConfig = (serviceConfig: any, ctx: { name: string; basePath: string; }) => {
        const newConfig = { ...serviceConfig };
        if (newConfig.baseURL) {
            newConfig.baseURL = newConfig.baseURL + ctx.basePath;
        }
        return newConfig;
    };

const customer = new Customer(warpperServiceConfig(serviceConfig, { name: 'customer', basePath: '/customer' }));
const goods = new Goods(warpperServiceConfig(serviceConfig, { name: 'goods', basePath: '/goods' }));
const order = new Order(warpperServiceConfig(serviceConfig, { name: 'order', basePath: '/order' }));
const settlement = new Settlement(warpperServiceConfig(serviceConfig, { name: 'settlement', basePath: '/settlement' }));
const smc = new Smc(warpperServiceConfig(serviceConfig, { name: 'smc', basePath: '/smc' }));
const wms = new Wms(warpperServiceConfig(serviceConfig, { name: 'wms', basePath: '' }));
const overseas = new Overseas(warpperServiceConfig(serviceConfig, { name: 'overseas', basePath: '' }));
const apis = new Apis(warpperServiceConfig(serviceConfig, { name: 'apis', basePath: '/api' }));
const market = new Market(warpperServiceConfig(serviceConfig, { name: 'market', basePath: '/market' }));
const purchase = new Purchase(warpperServiceConfig(serviceConfig, { name: 'purchase', basePath: '/purchase' }));

export const apiInstanceList = [{ key: 'customer', instance: customer }, { key: 'goods', instance: goods }, { key: 'order', instance: order }, { key: 'settlement', instance: settlement }, { key: 'smc', instance: smc }, { key: 'wms', instance: wms }, { key: 'overseas', instance: overseas }, { key: 'apis', instance: apis }, { key: 'market', instance: market }, { key: 'purchase', instance: purchase }];

export const api = { customer, goods, order, settlement, smc, wms, overseas, apis, market, purchase };